// builder-components.ts
import { Builder } from '@builder.io/react';

import FooterCallComponent from './footer-call-component';

Builder.registerComponent(FooterCallComponent, {
  name: 'FooterCallComponent',
  noWrap: true,
});
